import { render } from "./ClientMaster.vue?vue&type=template&id=7619ee47&scoped=true"
import script from "./ClientMaster.vue?vue&type=script&lang=js"
export * from "./ClientMaster.vue?vue&type=script&lang=js"

import "./ClientMaster.vue?vue&type=style&index=0&id=7619ee47&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\MSRTC\\MSRTC-CODE\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7619ee47"]])

export default __exports__